import { createI18n } from "vue-i18n";
import en from "../lang/en.json";
import da from "../lang/da.json";
import sv from "../lang/sv.json";
import no from "../lang/no.json";
import de from "../lang/de.json";
import pt from "../lang/pt.json";
import pl from "../lang/pl.json";
import fi from "../lang/fi.json";

export const messages = { en, da, sv, no, de, pt, pl, fi };
export type Locale = keyof typeof messages;

export function resolveLocale(locale: string): Locale {
  const language = locale.toLowerCase().replace(/_/g, "-").split("-")[0];
  if (language === "nb" || language === "nn") return "no";
  return Object.hasOwn(messages, language) ? (language as Locale) : "en";
}

export function createAppI18n(locale = "en") {
  return createI18n({
    legacy: false,
    locale: resolveLocale(locale),
    fallbackLocale: "en",
    messages,
    missingWarn: false,
    fallbackWarn: false,
  });
}
